'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _LinkageSelect = require('../components/LinkageSelect');

var _LinkageSelect2 = _interopRequireDefault(_LinkageSelect);

var _util = require('../components/LinkageSelect/util');

var _formFieldUtils = require('../common/formFieldUtils');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _DTButton = require('./component/DTButton');

var _DTButton2 = _interopRequireDefault(_DTButton);

var _ExportButton = require('../components/ExportButton');

var _ExportButton2 = _interopRequireDefault(_ExportButton);

var _EditForm = require('./component/EditForm');

var _EditForm2 = _interopRequireDefault(_EditForm);

var _SearchTable = require('./component/SearchTable');

var _SearchTable2 = _interopRequireDefault(_SearchTable);

var _SearchForm = require('./component/SearchForm');

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _utils = require('./utils');

var _scrollTo = require('../common/scrollTo');

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

var _ossUploadHelper = require('../common/oss-upload-helper');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var BigTable = (_temp = _class = function (_Field) {
  _inherits(BigTable, _Field);

  function BigTable(props) {
    _classCallCheck(this, BigTable);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.onFormReady = function () {
      // 每次打开弹窗都会重新生成一个子组件的 state，每次打开弹窗时也需要触发一次对应的 event
      var _this$props = _this.props,
          initialSchema = _this$props.initialSchema,
          children = _this$props.children,
          fieldId = _this$props.fieldId,
          $state = _this$props.$state,
          onRebindEvents = _this$props.onRebindEvents,
          onEditModalShow = _this$props.onEditModalShow;
      var _this$state = _this.state,
          modalMode = _this$state.modalMode,
          modalEditRow = _this$state.modalEditRow,
          operationUuid = _this$state.operationUuid,
          bigTableRowKey = _this$state.bigTableRowKey,
          modalLinkageAddRow = _this$state.modalLinkageAddRow;

      var childSchemas = initialSchema.children || (0, _utils.getFormComponents)(children);
      var subStates = {};
      if (!(0, _lodash.isEmpty)(childSchemas) && $state) {
        childSchemas.forEach(function (item) {
          var itemProps = item && item.props || {};
          var state = $state.getRoot().get(fieldId + '>' + itemProps.fieldId);
          state.set('disableCollect', true);
          // 保留组件对子组件状态的引用
          subStates[itemProps.fieldId] = state;

          // 如果第一次打开弹窗时是编辑数据
          if (modalMode === 'edit' && modalEditRow[itemProps.fieldId] !== undefined) {
            state.setVal(modalEditRow[itemProps.fieldId]);
          }

          // 如果打开弹窗时是共享联动选择的数据
          if (modalMode === 'add' && modalLinkageAddRow && modalLinkageAddRow[itemProps.fieldId] !== undefined) {
            state.setVal(modalLinkageAddRow[itemProps.fieldId]);
          }
        });
      }
      _this.subStates = subStates;
      onRebindEvents && onRebindEvents();
      onEditModalShow && onEditModalShow({
        rowRecord: {
          rowId: modalMode === 'edit' ? modalEditRow.id : '',
          operationUuid: operationUuid,
          bigTableRowKey: bigTableRowKey
        }
      });
    };

    _this.onSearchFormReady = function (searchFormInstance) {
      _this.searchFormInstance = searchFormInstance;
    };

    _this.onSearchTableReady = function (searchTableInstance) {
      _this.searchTableInstance = searchTableInstance;
    };

    _this.getRelaFormDataForParams = function () {
      var getRelaFormData = _this.props.getRelaFormData;

      var result = '';
      try {
        var formValue = getRelaFormData();
        var formData = formValue.content;
        result = JSON.stringify(formData);
      } catch (e) {
        console.error(e);
      }
      return result;
    };

    _this.getFormData = function () {
      return !(0, _lodash.isEmpty)(_this.subStates) && Object.keys(_this.subStates).reduce(function (result, key) {
        var state = _this.subStates[key];
        result[key] = state.getVal();
        return result;
      }, {});
    };

    _this.isValid = function () {
      var result = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.values(_this.subStates)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var state = _step.value;

          var _ref = state.getData() || {},
              hasError = _ref.hasError;

          if (hasError === true) {
            result = hasError;
            break;
          } else {
            var validateResult = state.forceValid();
            if (validateResult && validateResult.hasError === true) {
              result = true;
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (result) {
        setTimeout(function () {
          (0, _scrollTo.scrollToFirstError)(document.getElementById('advanced-card__edit-form'));
        }, 100);
      }
      return !result;
    };

    _this.fetchTableData = function (page, count) {
      var _this$props2 = _this.props,
          enableSearch = _this$props2.enableSearch,
          onPageLoad = _this$props2.onPageLoad,
          onResize = _this$props2.onResize,
          onChange = _this$props2.onChange;
      var _this$state2 = _this.state,
          params = _this$state2.params,
          current = _this$state2.current,
          pageSize = _this$state2.pageSize;

      var searchParam = enableSearch && _this.searchFormInstance ? _this.searchFormInstance.getData() : null;
      _this.setState({ showMask: true });
      return (0, _service.pageQuery)(params, page || current, count || pageSize, searchParam).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _this.setState({ showMask: false });
        var data = (res.list || []).map(function (item) {
          var rowData = {};
          try {
            rowData = JSON.parse(item.rowData);
          } catch (e) {}
          return _extends({}, item, rowData, { rowData: rowData });
        });
        onPageLoad({
          data: data,
          currentPage: res.current,
          totalCount: res.total
        });
        onChange({ value: { totalCount: res.total, data: data }, dataType: '' });
      });
    };

    _this.clearTableData = function () {
      var params = _this.state.params;
      var _this$props3 = _this.props,
          onPageLoad = _this$props3.onPageLoad,
          onChange = _this$props3.onChange;

      return (0, _service.clearTable)({
        sequenceNo: params.sequenceNo,
        tablePropertyId: params.tablePropertyId,
        matterId: params.matterId
      }).then(function () {
        _this.setState({ selectedRows: [] });
        onPageLoad && onPageLoad({
          data: [],
          currentPage: 1,
          totalCount: 0
        });
        onChange({ value: { totalCount: 0, data: [] } });
      });
    };

    _this.onTaskSuccess = function (data) {
      var reportFileUrl = data.reportFileUrl,
          succeed = data.succeed,
          total = data.total,
          reportMessage = data.reportMessage;

      _this.setState({
        failMsg: {
          show: true,
          reportFileUrl: reportFileUrl,
          succeed: succeed,
          total: total,
          reportMessage: reportMessage
        },
        uploading: false
      });
      if (!(0, _lodash.isEmpty)(reportMessage)) {
        _next.Message.error(reportMessage);
      }
      // if (succeed < 1) {
      //   return;
      // }
      _this.fetchTableData();
    };

    _this.onTaskError = function (e) {
      e && e.errorMsg && _next.Message.error(e && e.errorMsg);
      _this.setState({
        uploading: false
      });
    };

    _this.onTaskProgress = function (data) {
      if (!data) {
        return;
      }
      var total = data.total,
          guessTotalRows = data.guessTotalRows;

      if (typeof total !== 'number' || typeof guessTotalRows !== 'number' || guessTotalRows === 0) {
        return;
      }

      var progress = parseInt(total * 100 / guessTotalRows);
      _this.setState({
        uploading: true,
        uploadingProgress: progress
      });
    };

    _this.onFileUploadComplete = function (file, value) {
      var params = _this.state.params;
      var _file$originFileObj = file.originFileObj,
          ossUrl = _file$originFileObj.ossUrl,
          uuidName = _file$originFileObj.uuidName,
          fileKey = _file$originFileObj.fileKey;

      (0, _ossUploadHelper.registerFile)(uuidName, fileKey);

      _service2.default.head(ossUrl).then(function () {
        // issue 34393442
        var formData = _this.getRelaFormDataForParams();
        return (0, _service.upload)(_extends({}, params, { formData: formData, uploadFileOssUrl: ossUrl }));
      }).then(function () {
        (0, _service.uploadStatusQuery)(params, {
          onError: _this.onTaskError,
          onSuccess: _this.onTaskSuccess,
          onProgress: _this.onTaskProgress
        });
      }).catch(function (err) {
        _this.setState({
          uploading: false
        });
        var message = '上传失败';
        if (err) {
          if (err.message || err.errorMsg) {
            message = err.message || err.errorMsg;
          } else if (typeof err === 'string') {
            message = err;
          }
        }
        _next.Message.error({ title: message, duration: 2000 });
      });
    };

    _this.deleteRows = function () {
      var rowIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var rowKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var params = _this.state.params;

      return (0, _service.batchDelete)(_extends({
        rowIds: rowIds,
        rowKeys: rowKeys
      }, params));
    };

    _this.removeAllHandler = function () {
      // 调用后端删除全部方法，然后重新查询
      _next.Dialog.confirm({
        title: '确认',
        content: '确认清空所有数据?',
        onOk: function onOk() {
          _this.clearTableData();
        }
      });
    };

    _this.removeHandler = function (rowId, rowKey) {
      _next.Dialog.confirm({
        title: '确认',
        content: '确认删除该条数据?',
        onOk: function onOk() {
          _this.deleteRows([rowId], [rowKey]).then(function () {
            _next.Message.notice('删除行成功');
            _this.fetchTableData();
          });
        }
      });
    };

    _this.removeSelectedHandler = function () {
      var selectedRows = _this.state.selectedRows;

      if ((0, _lodash.isEmpty)(selectedRows)) {
        return;
      }
      _next.Dialog.confirm({
        title: '确认',
        content: '确认清空选中的所有数据?',
        onOk: function onOk() {
          _this.deleteRows(selectedRows.map(function (item) {
            return item.id;
          }), selectedRows.map(function (item) {
            return item.rowKey;
          })).then(function () {
            _next.Message.notice('删除行成功');
            _this.setState({ selectedRows: [] });
            _this.fetchTableData();
          });
        }
      });
    };

    _this.handleAddLinkageShare = function (rowData) {
      var _this$props4 = _this.props,
          value = _this$props4.value,
          onChange = _this$props4.onChange;
      // 更新脱敏operationUuid和rowId，用于异步请求获取大表格脱敏参数

      var operationUuid = (0, _formFieldUtils.uuid)();
      onChange({ value: _extends({}, value, rowData, { operationUuid: operationUuid, rowId: '', bigTableRowKey: '' }) });
      _this.setState({
        modalVisible: true,
        modalMode: 'add',
        modalTitle: '新增',
        operationUuid: operationUuid,
        rowId: '',
        bigTableRowKey: '', // 补齐补正脱敏参数
        modalLinkageAddRow: rowData
      });
    };

    _this.addHandler = function () {
      var _this$props5 = _this.props,
          value = _this$props5.value,
          onChange = _this$props5.onChange;
      // 更新脱敏operationUuid和rowId，用于异步请求获取大表格脱敏参数

      var operationUuid = (0, _formFieldUtils.uuid)();
      onChange({ value: _extends({}, value, { operationUuid: operationUuid, rowId: '', bigTableRowKey: '' }) });
      _this.setState({
        modalVisible: true,
        modalMode: 'add',
        modalTitle: '新增',
        operationUuid: operationUuid,
        rowId: '',
        bigTableRowKey: '' // 补齐补正脱敏参数
      });
    };

    _this.editHandler = function (rowData) {
      var _this$props6 = _this.props,
          value = _this$props6.value,
          onChange = _this$props6.onChange;
      // 更新脱敏operationUuid和rowId，用于异步请求获取大表格脱敏参数

      var operationUuid = (0, _formFieldUtils.uuid)();
      onChange({ value: { operationUuid: operationUuid, rowId: rowData.id, bigTableRowKey: rowData.rowKey } });
      _this.setState({
        modalVisible: true,
        modalMode: 'edit',
        modalTitle: '修改',
        modalEditRow: rowData,
        operationUuid: operationUuid, // 脱敏参数
        rowId: rowData.id, // 脱敏参数
        bigTableRowKey: rowData.rowKey // 补齐补正脱敏参数
      });
    };

    _this.errorHandler = function (_ref2) {
      var success = _ref2.success,
          errorMsg = _ref2.errorMsg,
          extraData = _ref2.extraData;

      _this.setState({ showModalMask: false });
      if (!success) {
        var hasInlineError = false;
        var errorMsgArr = [];
        if (!(0, _lodash.isEmpty)(extraData)) {
          extraData.forEach(function (item) {
            var state = _this.subStates[item.subId];
            if (state) {
              hasInlineError = true;
              state.invokeValidate(false, item.errorMsg);
            } else {
              errorMsgArr.push(item.errorMsg);
            }
          });
        }
        if (!hasInlineError) {
          if (!(0, _lodash.isEmpty)(errorMsgArr)) {
            _next.Message.error(errorMsgArr.join(',\n'));
          } else if (!(0, _lodash.isEmpty)(errorMsg)) {
            _next.Message.error(errorMsg);
          }
        }
      }
    };

    _this.onModalOk = function () {
      var _this$state3 = _this.state,
          params = _this$state3.params,
          modalMode = _this$state3.modalMode,
          modalEditRow = _this$state3.modalEditRow,
          operationUuid = _this$state3.operationUuid,
          bigTableRowKey = _this$state3.bigTableRowKey,
          modalLinkageAddRow = _this$state3.modalLinkageAddRow;

      _this.setState({ showModalMask: true });

      // 校验
      if (!_this.isValid()) {
        _this.setState({ showModalMask: false });
        return false;
      }
      var formData = _this.getFormData();
      var relateFormData = _this.getRelaFormDataForParams();
      if (modalMode === 'add') {
        (0, _service.saveRows)(_extends({}, params, { formData: relateFormData, operationUuid: operationUuid, bigTableRowKey: bigTableRowKey }), [{ rowData: _extends({}, modalLinkageAddRow, formData) }]).then(function (res) {
          _next.Message.notice('新增行成功');
          _this.setState({ modalVisible: false, showModalMask: false, modalLinkageAddRow: {} });
          _this.fetchTableData();
        }).catch(function (error) {
          return _this.errorHandler(error);
        });
      } else {
        var requestData = {
          rowId: modalEditRow.id,
          rowData: _extends({}, modalEditRow.rowData, formData)
        };
        (0, _service.saveRows)(_extends({}, params, { formData: relateFormData, operationUuid: operationUuid, bigTableRowKey: bigTableRowKey }), [requestData], true).then(function (res) {
          _next.Message.notice('修改行成功');
          _this.setState({ modalVisible: false, showModalMask: false });
          _this.fetchTableData();
        }).catch(function (error) {
          return _this.errorHandler(error);
        });
      }
    };

    _this.onModalClose = function () {
      _this.setState({ modalVisible: false, modalLinkageAddRow: {} });
      // 调用清除大表格脱敏缓存
      var _this$state4 = _this.state,
          params = _this$state4.params,
          operationUuid = _this$state4.operationUuid;

      (0, _service.removeBigTableCache)({ tablePropertyId: params.tablePropertyId, sequenceNo: params.sequenceNo, operationUuid: operationUuid });
    };

    _this.shareHandler = function () {
      var _this$props7 = _this.props,
          value = _this$props7.value,
          onChange = _this$props7.onChange;
      // 更新脱敏参数operationUuid和rowId

      var operationUuid = (0, _formFieldUtils.uuid)();
      // onChange({ value: { ...value, operationUuid, rowId: '' } });
      _this.setState({ searchModalVisible: true, operationUuid: operationUuid, rowId: '' });
    };

    _this.onSearchModalOk = function () {
      _this.setState({ searchModalVisible: false });
      _this.fetchTableData();
      // 调用清除大表格脱敏缓存
      var _this$state5 = _this.state,
          params = _this$state5.params,
          operationUuid = _this$state5.operationUuid;

      (0, _service.removeBigTableCache)({ tablePropertyId: params.tablePropertyId, sequenceNo: params.sequenceNo, operationUuid: operationUuid });
    };

    _this.subStates = {};
    _this.searchTableInstance = null;
    _this.state = _extends({}, _this.state, {
      selectedRows: [],
      current: 1,
      pageSize: props.pageSize || 10,
      params: (0, _utils.initRequestParams)(props.fieldId, props.global),
      uploading: false,
      uploadingProgress: 0,
      failMsg: {
        show: false
      },
      showMask: false,
      modalMode: 'edit',
      modalEditRow: {},
      modalLinkageAddRow: {},
      modalTitle: '编辑',
      modalVisible: false,
      showModalMask: false,
      searchModalVisible: false,
      columns: (0, _utils.generateColumns)(props)
    });
    return _this;
  }

  BigTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      columns: (0, _utils.generateColumns)(nextProps)
    });
  };

  BigTable.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    _Field.prototype.componentDidMount.call(this);
    var _state = this.state,
        params = _state.params,
        behavior = _state.behavior;
    var $state = this.props.$state;

    if (behavior === 'NORMAL') {
      (0, _service.queryUploadReport)(params).then(function () {
        _this2.fetchTableData();
      });
    } else {
      this.fetchTableData();
    }

    // TODO 监听事件，调用和事件名相同的函数，需要声明这个组件支持哪些事件（这期先不做成通用的）
    $state.emitter.on('clearTableData', function () {
      _this2.clearTableData().then(function () {
        $state.emitter.emit('clearTableData:end');
      });
    });
  };

  BigTable.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      labelAlign: 'top',
      fieldClassName: 'vc-big-table'
    });
  };

  /**加载表格数据 */


  /**清除表格数据 */


  BigTable.prototype.renderEditForm = function renderEditForm() {
    var _props = this.props,
        $state = _props.$state,
        children = _props.children;
    var _state2 = this.state,
        modalTitle = _state2.modalTitle,
        modalVisible = _state2.modalVisible;

    return _react2.default.createElement(
      _next.Dialog,
      {
        title: modalTitle,
        visible: modalVisible,
        shouldUpdatePosition: true,
        onOk: this.onModalOk,
        onClose: this.onModalClose,
        onCancel: this.onModalClose
      },
      _react2.default.createElement(_EditForm2.default, { owner: $state, subStates: this.subStates, children: children, initCallback: this.onFormReady })
    );
  };

  BigTable.prototype.renderShareTable = function renderShareTable() {
    var _props2 = this.props,
        rowSelector = _props2.rowSelector,
        pageData = _props2.pageData,
        enableSearch = _props2.enableSearch,
        searchTablePageSizeList = _props2.searchTablePageSizeList,
        enableShareSearch = _props2.enableShareSearch,
        $state = _props2.$state,
        children = _props2.children,
        searchColumns = _props2.searchColumns,
        dataShareSearchFields = _props2.dataShareSearchFields;
    var _state3 = this.state,
        searchModalVisible = _state3.searchModalVisible,
        columns = _state3.columns,
        params = _state3.params,
        operationUuid = _state3.operationUuid;

    return _react2.default.createElement(
      _next.Dialog,
      {
        title: '共享数据',
        visible: searchModalVisible,
        className: 'vc-big-table-share-dialog',
        width: '85%',
        footer: null,
        footerActions: ['ok'],
        onOk: this.onSearchModalOk,
        onCancel: this.onSearchModalOk,
        onClose: this.onSearchModalOk
      },
      _react2.default.createElement(_SearchTable2.default, {
        columns: columns,
        enableSearch: enableSearch,
        enableShareSearch: enableShareSearch,
        selectedCount: pageData.totalCount,
        pageSizeList: searchTablePageSizeList,
        searchFormProps: {
          formKey: (0, _formFieldUtils.uuid)(),
          owner: $state,
          children: children,
          searchColumns: searchColumns,
          dataShareSearchFields: dataShareSearchFields
        },
        params: _extends({}, params, { operationUuid: operationUuid }),
        rowSelector: rowSelector,
        onCancel: this.onSearchModalOk,
        getRelaFormDataForParams: this.getRelaFormDataForParams,
        initCallback: this.onSearchTableReady
      })
    );
  };

  BigTable.prototype.renderSearchForm = function renderSearchForm() {
    var _props3 = this.props,
        $state = _props3.$state,
        children = _props3.children,
        searchColumns = _props3.searchColumns;

    return _react2.default.createElement(_SearchForm2.default, {
      formKey: (0, _formFieldUtils.uuid)(),
      owner: $state,
      children: children,
      searchColumns: searchColumns,
      searchHandler: this.fetchTableData.bind(this),
      initCallback: this.onSearchFormReady
    });
  };

  BigTable.prototype.renderTopBar = function renderTopBar() {
    var _this3 = this;

    var _props4 = this.props,
        importMode = _props4.importMode,
        enableDelete = _props4.enableDelete,
        enableAdd = _props4.enableAdd,
        addButtonName = _props4.addButtonName,
        enableExport = _props4.enableExport,
        pageData = _props4.pageData,
        linkageShareData = _props4.linkageShareData;
    var _state4 = this.state,
        failMsg = _state4.failMsg,
        uploading = _state4.uploading,
        params = _state4.params,
        uploadingProgress = _state4.uploadingProgress;

    var uploaderCls = (0, _classnames2.default)('vc-big-table-upload', {
      'vc-big-table-upload-uploading-state': uploading
    });
    var spinCls = (0, _classnames2.default)({
      'vc-big-table-upload-uploading-state': !uploading,
      'vc-big-table-upload-uploading-progress': true
    });
    var correction = !!params.correction;
    var showLinkageShareBtn = linkageShareData ? (0, _util.showLinkageShare)(linkageShareData) : false;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'left-actions' },
        enableAdd && showLinkageShareBtn && _react2.default.createElement(_LinkageSelect2.default, { superProps: _extends({}, this.props), handleAdd: this.handleAddLinkageShare }),
        enableAdd && _react2.default.createElement(
          _next.Button,
          { type: 'secondary', onClick: this.addHandler },
          _react2.default.createElement(_next.Icon, { type: 'add' }),
          ' ',
          addButtonName
        ),
        !correction && (importMode === 'upload' || importMode === 'mix') && _react2.default.createElement(
          'div',
          { style: { display: 'inline-block' } },
          _react2.default.createElement(
            _next.Upload,
            {
              type: 'file',
              accept: '.xls,.xlsx',
              className: uploaderCls,
              onSuccess: this.onFileUploadComplete,
              formatter: _ossUploadHelper.uploadResultFormatter,
              onError: this.onTaskError,
              beforeUpload: function beforeUpload(file, options) {
                _this3.setState({
                  uploading: true,
                  uploadingProgress: 0
                });
                return (0, _ossUploadHelper.beforeUpload)(file, options, _extends({}, (0, _lodash.get)(global, 'formOptions', {}), {
                  sceneName: 'BIG_TABLE_FILE'
                }));
              }
            },
            _react2.default.createElement(
              _next.Button,
              { type: 'secondary' },
              _react2.default.createElement(_next.Icon, { type: 'upload' }),
              ' \u6279\u91CF\u5BFC\u5165'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: spinCls },
            _react2.default.createElement(_next.Progress, { percent: uploadingProgress })
          ),
          failMsg.show && (failMsg.reportFileUrl ? _react2.default.createElement(
            'a',
            { href: failMsg.reportFileUrl, target: '_blank', 'class': 'vc-gov-big-table-upload-error-text' },
            '\u5171\u8BA1 ',
            failMsg.total,
            ' \u884C \u6210\u529F ',
            failMsg.succeed,
            ' \u884C \u70B9\u51FB\u4E0B\u8F7D\u9519\u8BEF\u6570\u636E'
          ) : _react2.default.createElement(
            _next.Button,
            { text: true },
            '\u5171\u8BA1',
            failMsg.total,
            '\u884C, \u65B0\u589E',
            failMsg.succeed,
            ', \u89E3\u6790\u5B8C\u6210'
          ))
        ),
        !correction && (importMode === 'share' || importMode === 'mix') && _react2.default.createElement(
          _next.Button,
          { type: 'secondary', onClick: this.shareHandler },
          _react2.default.createElement(_next.Icon, { type: 'switch' }),
          ' \u5171\u4EAB\u6570\u636E'
        ),
        !correction && enableDelete && _react2.default.createElement(
          _next.Button,
          { text: true, onClick: this.removeSelectedHandler },
          '\u5220\u9664\u9009\u4E2D'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'right-actions' },
        enableExport && _react2.default.createElement(_ExportButton2.default, { scene: 'BigTable', params: params, disabled: !pageData.totalCount > 0 }),
        !correction && (importMode === 'upload' || importMode === 'mix') && _react2.default.createElement(_DTButton2.default, { params: params, getFormData: this.getRelaFormDataForParams }),
        !correction && enableDelete && _react2.default.createElement(
          _next.Button,
          { text: true, onClick: this.removeAllHandler },
          _react2.default.createElement(_next.Icon, { type: 'delete' }),
          ' \u6E05\u7A7A\u6570\u636E'
        )
      ),
      _react2.default.createElement('div', { className: 'clear-both' })
    );
  };

  BigTable.prototype.generateTableColumns = function generateTableColumns() {
    var _this4 = this;

    var _props5 = this.props,
        deleteButtonName = _props5.deleteButtonName,
        editButtonName = _props5.editButtonName,
        enableDelete = _props5.enableDelete,
        enableEdit = _props5.enableEdit;
    var _state5 = this.state,
        behavior = _state5.behavior,
        columns = _state5.columns,
        params = _state5.params;

    var isNormal = behavior === 'NORMAL';
    var realColumns = [].concat(_toConsumableArray(columns));
    var actionRender = function actionRender(value, index, record) {
      return _react2.default.createElement(
        'div',
        null,
        isNormal && enableEdit && !record.readonly && _react2.default.createElement(
          _next.Button,
          { type: 'primary', text: true, onClick: function onClick() {
              return _this4.editHandler(record);
            }, style: { marginRight: '10px' } },
          editButtonName || '编辑'
        ),
        isNormal && enableDelete && !record.readonly && _react2.default.createElement(
          _next.Button,
          { text: true, onClick: function onClick() {
              return _this4.removeHandler(record.id, record.rowKey);
            } },
          deleteButtonName || '删除'
        )
      );
    };
    // 增加补齐补正展示列
    if (params.correction) {
      realColumns.push({
        dataIndex: 'memo',
        title: '补齐补正提示'
      });
    }
    realColumns.push({
      dataIndex: 'action',
      title: isNormal ? '操作' : '',
      width: isNormal ? '8rem' : '1px',
      lock: 'right',
      cell: actionRender
    });
    (0, _utils.fillColumnsWidth)(realColumns);
    return realColumns.map(function (item) {
      return _react2.default.createElement(_next.Table.Column, item);
    });
  };

  // 渲染表单选择模式 checkbox tips


  BigTable.prototype.renderFieldCheckboxTips = function renderFieldCheckboxTips() {
    // 可通过全局配置修改
    var tips = (0, _lodash.get)(window.G_GOV_MESSAGE || {}, 'form.itemFieldSelectTips', '大表格最多支持选择500行发起补齐补正');
    return _react2.default.createElement(
      'span',
      { className: 'item-field-select-tips' },
      tips
    );
  };

  BigTable.prototype.renderTableLayout = function renderTableLayout() {
    var _this5 = this;

    var _props6 = this.props,
        pageData = _props6.pageData,
        enableDelete = _props6.enableDelete,
        rowSelector = _props6.rowSelector;
    var _state6 = this.state,
        showMask = _state6.showMask,
        pageSize = _state6.pageSize,
        behavior = _state6.behavior;

    // 通过 rowSelection 对象表明需要行选择

    var rowSelection = behavior === 'NORMAL' && enableDelete !== false ? {
      onSelect: function onSelect(selected, record, selectedRows) {
        _this5.setState({ selectedRows: selectedRows });
      },
      onSelectAll: function onSelectAll(selected, selectedRows) {
        _this5.setState({ selectedRows: selectedRows });
      }
    } : undefined;

    var onPagerChange = function onPagerChange(current) {
      _this5.setState({ current: current, selectedRows: [] }, function () {
        _this5.fetchTableData();
      });
    };

    var onPageSizeChange = function onPageSizeChange(pageSize) {
      _this5.setState({ current: 1, pageSize: pageSize }, function () {
        _this5.fetchTableData();
      });
    };

    var columns = this.generateTableColumns();

    var renderProps = {
      className: 'vc-big-table-table-body',
      dataSource: pageData.data,
      primaryKey: 'rowKey',
      loading: showMask,
      rowSelector: rowSelector,
      rowSelection: rowSelection
    };

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _next.Table,
        renderProps,
        columns
      ),
      pageData.totalCount > 0 && _react2.default.createElement(_next.Pagination, {
        style: { marginTop: '10px', textAlign: 'right' },
        pageSizeSelector: 'filter',
        pageSizePosition: 'end',
        pageSize: pageSize,
        onChange: onPagerChange,
        current: pageData.currentPage,
        total: pageData.totalCount,
        onPageSizeChange: onPageSizeChange
      })
    );
  };

  BigTable.prototype.renderDefaultView = function renderDefaultView() {
    var enableSearch = this.props.enableSearch;

    return _react2.default.createElement(
      'div',
      { className: 'vc-big-table-container', style: { width: '100%' } },
      enableSearch && this.renderSearchForm(),
      this.renderTableLayout()
    );
  };

  BigTable.prototype.renderControl = function renderControl() {
    var enableSearch = this.props.enableSearch;
    var behavior = this.state.behavior;

    return _react2.default.createElement(
      'div',
      { className: 'vc-big-table-container', style: { width: '100%' } },
      behavior === 'NORMAL' && this.renderTopBar(),
      this.renderEditForm(),
      this.renderShareTable(),
      enableSearch && this.renderSearchForm(),
      this.renderTableLayout()
    );
  };

  return BigTable;
}(_vuFusionField2.default), _class.displayName = 'BigTable', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  importMode: 'share',
  enableAdd: true,
  addButtonName: '单个增加',
  enableEdit: true,
  enableDelete: true,
  enableExport: false,
  params: {}
}), _class.defaultMutators = _extends({}, _vuFusionField2.default.defaultMutators, {
  onPageLoad: function onPageLoad(_ref3, pageData) {
    var state = _ref3.state;

    var prevPageData = state.getValue('pageData');
    state.set('pageData', _extends({}, prevPageData, pageData));
  }
}), _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['fieldId', 'label', 'behavior', 'fieldName', {
  name: 'groupId',
  formatOut: false
}, {
  name: 'initialSchema',
  formatIn: function formatIn(initialSchema, props, states) {
    var componentSchema = states.componentSchema;

    return componentSchema || {};
  }
}, {
  name: 'pageData',
  formatIn: function formatIn() {
    return {
      data: [],
      currentPage: 1,
      totalCount: 0
    };
  }
}, {
  name: 'fieldData',
  formatOut: function formatOut() {
    return {
      value: {
        data: [],
        totalCount: 0
      }
    };
  }
}]), _class.validators = {
  required: {
    valid: function valid(value, param) {
      return true;
      // TODO 先去掉前端校验
      // return !value || (value && value.total > 0);
    }
  }
}, _temp);
exports.default = BigTable;
module.exports = exports['default'];